export const Prose = ({ text = "" }) => (
  <div className="prose-eh">
    {text.split(/\n\n+/).map((block, i) => {
      if (block.startsWith("## ")) {
        const [head, ...rest] = block.split("\n");
        return (
          <div key={i}>
            <h2>{head.slice(3)}</h2>
            {rest.length > 0 && <p>{rest.join(" ")}</p>}
          </div>
        );
      }
      if (block.startsWith("- ")) {
        return <ul key={i}>{block.split("\n").map((l, j) => <li key={j}>{l.replace(/^- /, "")}</li>)}</ul>;
      }
      return <p key={i}>{block}</p>;
    })}
  </div>
);
